// extracted by mini-css-extract-plugin
export default {"wrap":"S_cN","navItem":"S_bN"};